import gsap from "gsap";
import {$dom} from '../../../helpers/dom';
import variables from '../../../variables';

const {
	exist
} = $dom;

export default function createProjectsAnimation(
	sectionSelector = '.js-home-projects',
	polygonSelector = '.js-home-polygon-background'
) {

	if (exist([
		sectionSelector,
		polygonSelector
	])) {

		const {md} = variables.breakpoints;

		return 	gsap.timeline({
			scrollTrigger: {
				trigger: sectionSelector,
				start: 'top bottom',
				end: '+=100%',
				scrub: true
			}
		}).fromTo(polygonSelector, {
			yPercent: variables.windowWidth > md ? -10 : -15
		}, {
			yPercent: 0
		})
			.from(sectionSelector, {
				yPercent: variables.windowWidth > md ? 20 : -5
			}, 0);
	}
}
